<template>
	<div class="content">
		<div class="row">

			<div class="card-box login-form">

				<div class="the_head">
					<h3 class="title">注册</h3>
				</div>

				<el-form :rules="rules">
					<div class="row" style="margin-top:10px;">
						<input name="captcha" type="text" v-model.trim="loginForm.invitationCode" autoComplete="on"
							placeholder="邀请码" class="form-control col-6">
					</div>

					<div class="row" style="margin-top:10px;">
						<input name="loginName" type="text" v-model.trim="loginForm.loginName" autoComplete="on"
							placeholder="请输入用户名" @click="clearMsg()" class="form-control col-12">
					</div>

					<div class="row" style="margin-top:10px;">
						<input name="password" :type="pwdType" v-model.trim="loginForm.password" autoComplete="on"
							placeholder="请输入密码" @click="clearMsg()" class="form-control col-12">
					</div>

					<div class="row" style="margin-top:10px;">
						<input name="tel" type="tel" v-model.trim="loginForm.mobile" autoComplete="on"
							placeholder="请输入电话号码" class="form-control col-3">

					</div>

					<div class="the_head" style="color:red;margin:10px;height:20px;">
						{{msg}}
					</div>

					<div style="height: 20px;">已有账号？<a href="/#/login">登录</a></div>
				</el-form>

				<button class="btn btn-primary" @click="register()">
					注册
				</button>

			</div>
		</div>
	</div>
</template>

<script>
	import {
		Card
	} from "@/components/index";
	import {
		verificationNG0
	} from "@/config/validate";
	import {
		Message,
		MessageBox
	} from "element-ui";
	export default {
		data() {
			return {
				loginForm: {
					loginName: "",
					password: "",
					captchaKey: "",
					captcha: "",
					invitationCode: "",
					authKey: "",
					imgCode: "",
					mobile: "",
				},
				rules: {
					tel: [{
						required: true,
						message: "客户编码不能为空",
						trigger: "blur"
					}, ],
				},
				loading: false,
				pwdType: "password",
				timeStamp: "",
				imgCodeUrl: "",
				time: 60,
				sendMsg: true,
				lock: false,
				msg: "",
				endTime: "",
			};
		},
		created() {
			//this.loginForm.authKey="kt"+new Date().getTime();
			//this.imgCodeUrl=this.$serverUrl+"/authcode?authKey="+this.loginForm.authKey+"&timestamp=" + new Date().getTime();
		},
		methods: {
			validatePhone(event) {
				const phoneRegex = /^[0-9]*$/;
				if (!phoneRegex.test(event.target.value)) {
					this.error = 'Only numbers are allowed'
					event.target.value = this.loginForm.mobile
				} else {
					this.error = ''
					this.loginForm.mobile = event.target.value
				}
			},
			showPwd() {
				if (this.pwdType === "password") {
					this.pwdType = "";
				} else {
					this.pwdType = "password";
				}
			},
			async send() {
				if (this.loginForm.mobile == "") {
					this.msg = "请输入电话号码";
				} else {
					if (this.sendMsg) {
						this.loginForm.captchaKey = "kt" + new Date().getTime();
						let obj = {
							captchaKey: this.loginForm.captchaKey,
							tel: this.loginForm.mobile
						}
						let result = await this.$axios.post(this.$serverUrl + "/getCaptcha", obj);
						if (result.data.success == true) {
							this.sendMsg = false;
							let timer = setInterval(() => {
								this.time -= 1;
								if (this.time <= 0) {
									clearInterval((timer));
									this.sendMsg = true;
									this.time = 60
								}
							}, 1000);
						}
					}
				}
			},
			// refreshImgCode(){
			// 	this.loginForm.authKey="kt"+new Date().getTime();
			// 	this.imgCodeUrl=this.$serverUrl+"/authcode?authKey="+this.loginForm.authKey+"&timestamp=" + new Date().getTime();
			// },
			async register() {
				this.msg = "";
				let res = await this.$axios.post(this.$serverUrl + "/user/register", this.loginForm);

				if (JSON.stringify(res.data).includes(JSON.stringify("status"))) {
					Message({
						type: "success",
						message: "注册成功，请登录",
						offset: window.screen.height / 2 - 100,
						showClose: true
					});
					this.$router.push('/login');
				} else {
					if (res.data.state == 500) {
						Message({
							type: "error",
							message: res.data.msg,
							offset: window.screen.height / 2 - 100
						});
					}
				}
			},
			clearMsg() {
				this.msg = "";
			},
			countdown() {
				const now = new Date().getTime();
				const distance = this.endTime - now;
				if (distance >= 0) {
					// 计算时分秒
					//const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
					//const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
					const seconds = Math.floor((distance % (1000 * 60)) / 1000);
					//return `${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
					this.sendMsgDisabled = false;
					return seconds;
				} else {
					this.time = 60;
					this.sendMsgDisabled = true;
				}
			},
		},
	};
</script>

<style>

</style>